import React from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";
import BButton from "@components/BButton";
import AreaMenu from "./AreaMenu";

const NavigationHeaderMenuDesktop: React.FC<{}> = () => {

  return (
    <NavigationHeaderMenuDesktopContainer>
      <AreaMenu />
      <NavigationHeaderMenuDesktopLink href="/blog/">
        BLOG
      </NavigationHeaderMenuDesktopLink>
      <NavigationHeaderMenuDesktopLink href="/science">
        SCIENCE
      </NavigationHeaderMenuDesktopLink>
      <TakeQuizButton>
        <BButton href="/quiz" text="TAKE QUIZ" arrow={true}/>
      </TakeQuizButton>
    </NavigationHeaderMenuDesktopContainer>
  );
};

export default NavigationHeaderMenuDesktop;

const NavigationHeaderMenuDesktopContainer = styled.div`
  display: flex;
  align-items: center;
  
  ${mediaqueries.tablet`
    display: none;
  `}
`;

const NavigationHeaderMenuDesktopLink = styled.a`
  padding: 0 8px;
  margin: 0 12px;
  color: #000000;
`;

const TakeQuizButton = styled.div`
  margin-left: 12px;
`;
